// removed by extract-text-webpack-plugin
module.exports = {"container":"cards-production-container","image":"cards-production-image","link":"cards-production-link","mask":"cards-production-mask","label":"cards-production-label","hoverIn":"cards-production-hoverIn","hoverOut":"cards-production-hoverOut","more":"cards-production-more","text":"cards-production-text","inner":"cards-production-inner","category":"cards-production-category","title":"cards-production-title"};


//////////////////
// WEBPACK FOOTER
// ./styles/cards/production.scss
// module id = 811
// module chunks = 246